<template>
    <div>
        <ArboNode
            class="p-2"
            :menu="menu"
            :selections="selections"
            :selected-menu-id="selectedMenuId"
            @action="onAction"
        />
    </div>
</template>

<script>
import ArboNode from "./ArboNode.vue";
export default {
    components: {
        ArboNode,
    },

    props: {
        arbo: Array,
        selections: Object,
        selectedMenuId: [String, Number],
    },

    computed: {
        menu() {
            return {
                children: this.arbo,
            };
        },
    },

    methods: {
        onAction(payload) {
            this.$emit("action", payload);
        },
    },
};
</script>
